import { Loading } from '@orobix/orobix-fe-components'
import { useQuery } from '@tanstack/react-query'

import { get } from '../../utils/api'

type Anomaly = {
  id: number
  name: string
  code: string
  creationDate: Date
}

export const AnomalyStrategyProperty = ({
  anomalyStrategyId,
}: {
  anomalyStrategyId: number
}) => {
  const { data, isLoading, isError } = useQuery<Anomaly>(
    ['anomaly_strategies', anomalyStrategyId],
    () => get<Anomaly>(`/anomaly_strategies/${anomalyStrategyId}`),
    { retry: false }
  )

  return (
    <>
      {isError && '-'}
      {isLoading && <Loading />}
      {data && data.name}
    </>
  )
}
